import React, {useState, useEffect, useCallback} from 'react'

import {ChevronDownIcon, DocumentDuplicateIcon, InformationCircleIcon} from '@heroicons/react/24/solid';
import { 
  ButtonGroup, 
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography, 
  Textarea,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Spinner,
  IconButton,
  Slider,
  Select, 
  Option,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Tooltip,
  Radio,
  Checkbox
} from "@material-tailwind/react";

import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, loopTilAddressReceivesMoney, waitSomeSeconds, addressReceivedMoneyInThisTx, pushBTCpmt, calculateFeeNew, getData, isValidTaprootAddress} from '../../util/inscribe-util';

import { CheckIcon } from '@heroicons/react/24/solid';
import { useParams } from 'react-router-dom';
import { sendBtcTransaction } from 'sats-connect';
import FeeRateCard from '../../components/FeeRateCard';
import { BitcoinNetworkType, signMessage, signTransaction } from 'sats-connect';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import toast, { Toaster } from 'react-hot-toast';
import { useWallet, useWallets } from '@wallet-standard/react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import { launchpadTokenRandom } from '../../util/new-api';
import { op20Fee, op20FeeAddress, op20TransferFee } from '../../configs/constant';
import { getOp20CheckTicker, getOp20TickerDetail, getOp20InscribeUtxos, getOp20InscribeUtxosBulk } from '../../util/op20-api';
import { strToHex } from '../../util/format-data';
import { getOp20TransactionUtxo, getMaraInfo, getPaymentUtxosOp20Inscribe, getPaymentUtxosOp20InscribeBulk, getOp20UtxosForTransfer, getOp20BalanceTicker, getOp20UtxosForUtxoTransfer, getOp20DomainCheck, getPaymentUtxosOp20NameBulkMint, getOp20TransactionUtxoForDomain, getOp20DomainNameForMode, getOp20DomainAddress} from '../../util/op20-api';
import { sendMaraTx } from '../../util/op20-api';
import { useDropzone } from 'react-dropzone';
import { formatInscriptionIdMini } from '../../util/format-data';
import { v4 as uuidv4 } from 'uuid';
import { formatNumberWithCommas, checkValidBitcoinAddressLength } from '../../util/format-data';
import { useLocation } from 'react-router-dom';
import Op20HotDomains from '../../components/Modals/Op20HotDomains';

export default function Op20Inscribe() {
  
  const currentPath = useLocation().pathname;

  const { param } = useParams();
  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const { t, i18n } = useTranslation();
  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);
  const prices = useSelector(state => state.price);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const feeRates = useSelector(state => state.feeRate);

  const [feeValues, setFeeValues] = useState({
    "inscriptionFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "royaltyFee": 0,
    "totalFee": 0
  });

  const [loading, setLoading] = useState(false);
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [inscriptionStatus, setInscriptionStatus] = useState(false);
  const [showFeeRateCard, setShowFeeRateCard] = useState(false);

  const [type, setType] =  useState(currentPath.includes('mint') ? 1 : currentPath.includes('transfer') ? 2 : 4);

  const [ticker, setTicker] = useState(param);
  const [supply, setSupply] = useState(21000000);
  const [unitSats, setUnitSats] = useState(546);
  const [maxSats, setMaxSats] = useState(546000000);
  const [limSats, setLimSats] = useState('');
  const [mintText, setMintText] = useState('');
  const [outputSats, setOutputSats] = useState(546);
  const [amount, setAmount] = useState(1);
  const [isLoyalty, setIsLoyalty] = useState(1);
  const [isDeployTickerValid, setIsDeployTickerValid] = useState(0);
  const [receiveAddress, setReceiveAddress] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [searchOutput, setSearchOutput] = useState('');
  const [searchAmount, setSearchAmount] = useState(0);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(1000);
  const [dust20Data, setDust20Data] =  useState([]);
  const [checkedData, setCheckedData] = useState([]);
  const [maraData, setMaraData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrl, setPreviewUrl] = useState('');
  const [imageData, setImageData] = useState('');
  const [fileData, setFileData] = useState('');
  const [collectionName, setCollectionName] = useState('');
  const [maraFeeRate, setMaraFeeRate] = useState(0);
  const [tickerBalance, setTickerBalance] = useState({
    totalBalance: 0,
    transferableBalance: 0,
    availableBalance: 0
  })
  const [isInscribeTransfer, setIsInscribeTransfer] = useState(true);
  const [balanceUtxos, setBalanceUtxos] = useState([]);
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [checkAll, setCheckAll] = useState(false);
  const [name, setName] = useState('');
  const [showHotDomain, setShowHotDomain] = useState(false);
  const [names, setNames] = useState([""]);
  const [isDomainMint, setIsDomainMint] = useState(true);
  const [isDomainInscribeTransfer, setIsDomainInscribeTransfer] = useState(true);
  const [selectedDomainNameData, setSelectedDomainNameData] = useState([]);
  const [selectedDomainName, setSelectedDomainName] = useState("");
  const [mintTextDraft, setMintTextDraft] = useState("");
  const [tickerResults, setTickerResults] = useState([]);
  const [domainForAddress, setDomainForAddress] = useState([]);
  const [showDomainForAddress, setShowDomainForAddress] = useState(false);

  useEffect(() => {

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(parseFloat(customFee));
          setFeeValues(calculateFeeRandom(parseFloat(customFee)));
        }
        else
        {
          setFeerate(feeRates[feeRateMode]);
          setFeeValues(calculateFeeRandom(feeRates[feeRateMode]));
          if (customFee == 0) 
          {
            setCustomFee(feeRates["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
  }, [feeRateMode, amount, customFee, isLoyalty, outputSats, fileData, type, feeRates, names])

  useEffect(() => {
    let intervalId;
    const updateMaraFees = async () => {
      try {
        let maraInfo = await getMaraInfo();
        setMaraFeeRate(maraInfo.feerate);
      }
      catch (e) {
        console.log(e);
      }
    }

    updateMaraFees();
    intervalId = setInterval(updateMaraFees, 40 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [])

  useEffect(() => {
    handleTickerResults();
  }, [ticker, type])

  const handleTickerResults = async () => {
    if (ticker != "" && ticker != undefined) {
      let result = await getOp20TickerDetail(ticker);
      if (result.length > 0) {
        setTickerResults(result);
      }
      else {
        setTickerResults([]);
      }
    }
  }

  useEffect(() => {
    if (type == 0) {
      setMintTextDraft(`{"p":"op-20","op":"deploy","tick":"${ticker}","max":"${supply}","lim":"${limit}", "add": "${receiveAddress}"}`);
    }
    else if (type == 1 && tickerResults.length > 0) {
      setMintTextDraft(`{"p":"op-20","op":"mint","tick":"${ticker}","amt":"${tickerResults[0].lim}","add":"${receiveAddress}"}`);
    }
    else {
      setMintTextDraft("");
    }
  }, [ticker, receiveAddress, supply, limit, type, tickerResults]);

  useEffect(() => {
    if (!isDomainMint) {
      fetchDomainNameData();
    } 
    setSelectedDomainName("");
  }, [isDomainMint, isDomainInscribeTransfer, wallet.nostrOrdinalsAddress])

  const fetchDomainNameData = async () => {
    let result = await getOp20DomainNameForMode(wallet.nostrOrdinalsAddress, isDomainInscribeTransfer ? 0 : 1, "");
    setSelectedDomainNameData(result);
  }

  useEffect(() => {
    setFeeValues(calculateFeeRandom(feeRates[feeRateMode]));
  }, [])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  useEffect(() => {
    if (unitSats > 0 && supply > 0){
      setMaxSats(unitSats * supply);
    }
  }, [unitSats, supply])

  const handleDomain = useCallback((value) => {
    setNames(value);
  }, []);

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  useEffect(() => { 
    setReceiveAddress(wallet.nostrOrdinalsAddress);
    handleRoyalty(wallet.nostrOrdinalsAddress);
  }, [wallet.nostrOrdinalsAddress]);

  useEffect(() => {
    setAmount(1);
    checkValidTicker(ticker);
  }, [type])

  useEffect(() => {
    if (type == 2 && isDeployTickerValid) {
      fetchBalanceTicker();
    }
    else {
      setTickerBalance({
        totalBalance: 0,
        transferableBalance: 0,
        availableBalance: 0
      })
      setBalanceUtxos([]);
    }
  }, [type, isDeployTickerValid])

  useEffect(() => {
    if (checkValidBitcoinAddressLength(receiveAddress)) {
      fetchDomainNameForAddress();
    }
    else {
      setDomainForAddress([]);
    }
  }, [receiveAddress])

  const fetchDomainNameForAddress = async () => {
    let results = await getOp20DomainAddress("", receiveAddress, 1, 100);
    setDomainForAddress(results.data);
  }

  const fetchBalanceTicker = async () => {
    let result = await getOp20BalanceTicker(wallet.nostrOrdinalsAddress, ticker);
    if (result.balance == 0) {
      setTickerBalance({
        totalBalance: 0,
        transferableBalance: 0,
        availableBalance: 0
      })
      setBalanceUtxos([]);
    }
    else {
      let transferableBalance = result.utxos.reduce((acc, utxo) => acc + utxo.amount, 0);
      let availableBalance = result.balance - transferableBalance;
      setTickerBalance({
        totalBalance: result.balance,
        transferableBalance: transferableBalance,
        availableBalance: availableBalance
      })
      setBalanceUtxos(result.utxos);
    }
  }

  const handleMintTicker = async (value) => {
    setTicker(value);
    debouncedCheckTickerIsValid(value);
  }

  const debouncedCheckTickerIsValid = useCallback(debounce(async (value) => {
    await checkValidTicker(value);
  }, 800), []); 

  const checkValidTicker = async (value) => {
    if (value != '' && value != undefined) {
      let result = await getOp20CheckTicker(value);
      if (result.status) {
        setIsDeployTickerValid(true);
      }
      else {
        setIsDeployTickerValid(false);
      }
    }
    else {
      setIsDeployTickerValid(false);
    }
  }

  const handleRoyalty = async(value) => {
    if (value == '') {
      setIsLoyalty(1);
    }
    else {
      let results = await launchpadTokenRandom(value, 2) // opzero
      if (results.data.length > 0) {
        setIsLoyalty(0);
      }
      else setIsLoyalty(1);
    }
  }

  const handleType = (value) => {
    setType(value);
  }

  const handleTicker = (value) => {
    setTicker(value);
  }

  const calculateFeeRandom = (feerate) => {
    let tempAmount = parseInt(amount);

    let unitFee = Math.ceil((160) * 1.26 * (feerate + 1));

    if (type == 3) {// inscribe
      unitFee = Math.ceil((100 + fileData.reduce((acc, file) => acc + file.length, 0)) * 1.26 * (feerate + 1)) + 330;;
    }

    let inscriptionFee = Math.ceil(unitFee * tempAmount);
    let networkFee = Math.ceil(feerate * (10 + 57.5 + 32 * tempAmount + 43.5) + (feerate + 1) * (10 + 67.5 + 43.5) * tempAmount);
    let serviceFee = Math.ceil(op20Fee) * isLoyalty;
    if (isLoyalty == 0) serviceFee = 1000;
    let totalFee = inscriptionFee + networkFee + serviceFee * tempAmount;

    if (type == 2 || type == 4) {
      if (isLoyalty == 0) {
        serviceFee = 1000;
        if (type == 4 && isDomainMint) serviceFee = 1000 * names.length;
      }
      else {
        serviceFee = op20TransferFee;
        if (type == 4 && isDomainMint) serviceFee = op20Fee * names.length;
      }

      if (isInscribeTransfer || type == 4) {
        totalFee = Math.ceil((150 + 80 * 1.26) * feerate + 333 + serviceFee)
        if (type == 4) totalFee = Math.ceil((150 + 80 * 1.26) * feerate * names.length + 333 * names.length + serviceFee);
      }
      else {
        totalFee = Math.ceil(150 * feerate + 333 + serviceFee)
      }
    }

    return {
      "inscriptionFee": inscriptionFee,
      "networkFee": networkFee,
      "serviceFee": serviceFee,
      "totalFee": totalFee
    }
  }  

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  const handleSubmit = async (type) => {
    setLoading(true);
    let tempTextArray = [];
    let tempText = '';
  
    if (type == 4 && isDomainMint) {
      handleOp20DomainInscribe();
      return;
    }

    if (type == 4 && !isDomainMint) {
      handleOp20DomainTransfer();
      return;
    }

    if (wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Connect Wallet Error Message'));  
      setLoading(false);
      return;
    }

    if (receiveAddress == "") {
      toast.error(t('Insert Receive Address Error Message'));
      setLoading(false);
      return;
    }

    if (type != 3 && (ticker == "" || ticker == undefined)) {
      toast.error(t('Please Insert Ticker Error Message'));
      setLoading(false);
      return;
    }

    const newFees = await getFeeRate();

    // if (parseFloat(feerate) < newFees["Fast"]) {
    //   toast.error(t('Feerate should be greater than') + ' ' + newFees["Fast"]);
    //   setLoading(false);
    //   return;
    // }

    /*
    try {
      let maraInfo = await getMaraInfo();
      if (maraInfo.status == "success" && parseFloat(feerate) < maraInfo.feerate) {
        toast.error(t('Feerate should be greater than') + ' ' + maraInfo.feerate);
        setLoading(false);
        return;
      }
    }
    catch(e) {
      console.log(e);
    }
      */

    // let tickerResults = await getOp20TickerDetail(ticker);

    if (type == 0) {

      if (tickerResults.length > 0) {
        toast.error(t('Ticker Already Exist Error Message'));  
        setLoading(false);
        return;
      }

      if (supply == '' || parseInt(supply) <=0) {
        toast.error(t('Insert Valid Supply Error Message'));  
        setLoading(false);
        return;
      }

      if (limit == '' || parseInt(limit) <=0) {
        toast.error(t('Insert Valid Limit Error Message'));  
        setLoading(false);
        return;
      }

      tempText = `{"p":"op-20","op":"deploy","tick":"${ticker}","max":"${supply}","lim":"${limit}", "add": "${receiveAddress}"}`;
    }
    else if (type == 1) {
      if (amount == '' || parseInt(amount) <= 0 || parseInt(amount) > 5) {
        toast.error(t('Insert Valid Amount Error Message'));  
        setLoading(false);
        return;
      }
      
      // if (tickerResults.length == 0) {
      //   toast.error(t('Ticker Not Found Error Message'));  
      //   setLoading(false);
      //   return;
      // }
      
      if (tickerResults[0].mintedAmount + amount > tickerResults[0].supply) {
        toast.error(t('Supply Not Enough Error Message'));  
        setLoading(false);
        return;
      }
      
      tempText = `{"p":"op-20","op":"mint","tick":"${ticker}","amt":"${tickerResults[0].lim}","add":"${receiveAddress}"}`;
    }
    else if (type == 3) {
      if (fileData.length == 0) {
        toast.error(t('Please Insert File Error Message'));
        setLoading(false);
        return;
      }

      console.log("---amount----", amount);
      if (collectionName != "") {
        tempTextArray = fileData.map(file => strToHex(`{"add": "${receiveAddress}", "collection": "${collectionName}"} ${file}`));
      }
      else {
        tempTextArray = fileData.map(file => strToHex(`{"add": "${receiveAddress}"} ${file}`));
      }
    }

    console.log("---tempfeerate----", feerate);
    console.log("---tempText----", tempText);

    let tempfeerate = parseFloat(feerate);
    if (tempfeerate <= 1) {
      tempfeerate = 1.1;
    }

    if (wallet.domain == "xverseWallet") tempfeerate = Math.ceil(feerate * 1.2);

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      toast.error(t('Feerate should be greater than') + ' ' + 1);
      setLoading(false);
      return;
    }

    let paramUtxos;
    let paymentUtxos;

    if (type == 3) {
      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        ordinalAddress: wallet.nostrOrdinalsAddress,
        fundingAmount: feeValues.serviceFee * amount, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        amount: parseInt(amount), 
        provider: wallet.domain, 
        keyArray: tempTextArray
      }
      paymentUtxos = await getPaymentUtxosOp20InscribeBulk(paramUtxos)
    }
    else {
      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        amount: parseInt(amount), 
        provider: wallet.domain, 
        key: strToHex(tempText)
      }
      paymentUtxos = await getOp20InscribeUtxosBulk(paramUtxos)
    }

    setShow(true);
    setInscriptionStatus(false);
    let isSuccess = true;
    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        setShow(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      setShow(false);
      return;
    }

    if (isSuccess) {
      let transactionData;

      while(true)
      {
        transactionData = await getMempoolUtxos(paymentUtxos.fundingAddress);
        if ( transactionData != undefined && transactionData.length >= 1){
          break;
        }
        await waitSomeSeconds(3);
      }

      let tempData = [];

      for(let i = 0; i< amount; i++){
        let paramData = {
          id: paymentUtxos.ids[i],
          utxo: {
            txid: transactionData[i].txid,
            vout: parseInt(transactionData[i].vout),
            value: parseInt(transactionData[i].value)
          }
        }

        let transactionUtxo = await getOp20TransactionUtxo(paramData);
        tempData.push(transactionUtxo);
        await waitSomeSeconds(1);

        setMaraData(tempData);
      }

      setLoading(false);
      setInscriptionStatus(true);
    }
    setLoading(false);
  }

  const handleSliderAmount = (value) => {
    setAmount(parseInt(value / 20))
  }

  const handleAmount = (value) => {
    if (parseInt(value) > 5) {
      setAmount(5);
    }
    else if (parseInt(value) < 1) {
      setAmount(1);
    }
    else {
      setAmount(parseInt(value));
    }
  }

  const handleChecked = (id) => {
    for(let utxo of balanceUtxos) {
      if (utxo.id == id) {
        if (utxo.checked == undefined) {
          utxo.checked = true;
        }
        else {
          utxo.checked = !utxo.checked;
        }
      }
    }
    setBalanceUtxos(balanceUtxos);
    setSelectedAmount(balanceUtxos.filter(utxo => utxo.checked).reduce((acc, utxo) => acc + parseInt(utxo.amount), 0));
  }
  
  const handleCheckAll = () => {
    if (checkAll) {
      for(let utxo of balanceUtxos) {
        utxo.checked = false;
      }
    }
    else {
      for(let utxo of balanceUtxos) {
        utxo.checked = true;
      }
    }
    setBalanceUtxos(balanceUtxos);
    setSelectedAmount(balanceUtxos.filter(utxo => utxo.checked).reduce((acc, utxo) => acc + parseInt(utxo.amount), 0));
    setCheckAll(!checkAll);
  }

  const handleTransfer = async () => {
    if (!isDeployTickerValid) {
      toast.error(t('Ticker Not Found Error Message'));
      return;
    }

    if (isInscribeTransfer && wallet.nostrOrdinalsAddress != wallet.nostrPaymentAddress) {
      toast.error(t('Only support Unisat and Universe wallet.'));
      setLoading(false);
      return;
    }

    if (isInscribeTransfer && amount > tickerBalance.availableBalance) {
      toast.error(t('Amount should be less or equal to available balance.'));
      return;
    }

    if (receiveAddress == "") {
      toast.error(t('Insert Receive Address Error Message'));
      return;
    }

    const selectedUtxos = balanceUtxos.filter(utxo => utxo.checked);

    if (!isInscribeTransfer && selectedUtxos.length == 0) {
      toast.error(t('Please select at least one utxo.'));
      return;
    }
    

    let tempText = `{"p": "op-20", "op": "transfer", "tick": "${ticker}", "amt": "${amount}"}`;

    console.log(tempText);

    let tempfeerate = parseFloat(feerate);
    if (tempfeerate <= 1) {
      tempfeerate = 1.1;
    }

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      toast.error(t('Feerate should be greater than') + ' ' + 1);
      setLoading(false);
      return;
    }

    let paramUtxos;
    let paymentUtxos;

    if (isInscribeTransfer) {
      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        provider: wallet.domain, 
        key: strToHex(tempText),
        receiverAddress: receiveAddress
      }
      paymentUtxos = await getOp20UtxosForTransfer(paramUtxos)
    }
    else {
      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        provider: wallet.domain, 
        balanceUtxos: selectedUtxos,
        receiverAddress: receiveAddress
      }
      paymentUtxos = await getOp20UtxosForUtxoTransfer(paramUtxos)
    }

    setShow(true);
    setInscriptionStatus(false);
    let isSuccess = true;
    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        setShow(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      setShow(false);
      return;
    }

    if (isSuccess) {
      setLoading(false);
      setInscriptionStatus(true);
    }
    setLoading(false);
  }

  const handleOp20DomainInscribe = async () => {
    if (wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Connect Wallet Error Message'));  
      setLoading(false);
      return;
    }

    if (receiveAddress == "") {
      toast.error(t('Insert Receive Address Error Message'));
      setLoading(false);
      return;
    }

    if (names.length == 1) {
      let domainCheck = await getOp20DomainCheck(names[0]);
      if (domainCheck.status) {
        toast.error(t('Domain already exists'));
        setLoading(false);
        return;
      }
    }

    for(let name of names) {
      if (name == "") {
        toast.error(t('Insert Name Error Message'));
        setLoading(false);
        return;
      }

      if (name.split(".").length != 2) {
        toast.error(t('Invalid Name Error Message'));
        setLoading(false);
        return;
      }
    }

    let tempfeerate = parseFloat(feerate);
    if (tempfeerate <= 1) {
      tempfeerate = 1.1;
    }

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      toast.error(t('Feerate should be greater than') + ' ' + 1);
      setLoading(false);
      return;
    }

    let paramUtxos;
    let paymentUtxos;

    if (names.length == 1) {
      let tempText = `${names[0]}`;
      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        provider: wallet.domain, 
        key: strToHex(tempText),
        receiverAddress: receiveAddress
      }
      paymentUtxos = await getOp20UtxosForTransfer(paramUtxos)
    }
    else {
      let keyArray = [];
      for(let name of names) {
        keyArray.push(strToHex(name));
      }

      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        provider: wallet.domain, 
        keyArray: keyArray,
        receiverAddress: receiveAddress
      }
      paymentUtxos = await getPaymentUtxosOp20NameBulkMint(paramUtxos)
    }

    setShow(true);
    setInscriptionStatus(false);
    let isSuccess = true;
    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        setShow(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      setShow(false);
      return;
    }

    if (isSuccess) {
      if (names.length > 1) {
        let transactionData;

        while(true)
        {
          transactionData = await getMempoolUtxos(paymentUtxos.fundingAddress);
          if ( transactionData != undefined && transactionData.length >= 1){
            break;
          }
          await waitSomeSeconds(3);
        }

        let tempData = [];

        for(let i = 0; i< names.length; i++){
          let paramData = {
            id: paymentUtxos.ids[i],
            utxo: {
              txid: transactionData[i].txid,
              vout: parseInt(transactionData[i].vout),
              value: parseInt(transactionData[i].value)
            }
          }

          let transactionUtxo = await getOp20TransactionUtxoForDomain(paramData);
          await waitSomeSeconds(1);
        } 

      }
      
      setLoading(false);
      setInscriptionStatus(true);
    }
    setLoading(false);
  }

  const handleOp20DomainTransfer = async () => {

    if (isDomainInscribeTransfer && wallet.nostrOrdinalsAddress != wallet.nostrPaymentAddress) {
      toast.error(t('Only support Unisat and Universe wallet.'));
      setLoading(false);
      return;
    }

    if (selectedDomainName == "") {
      toast.error(t('Please select a domain name.'));
      setLoading(false);
      return;
    }

    if (receiveAddress == "") {
      toast.error(t('Insert Receive Address Error Message'));
      setLoading(false);
      return;
    }

    let tempText = `{"p": "opns","op": "transfer","name": "${selectedDomainName}"}`;

    console.log(tempText);

    let tempfeerate = parseFloat(feerate);
    if (tempfeerate <= 1) {
      tempfeerate = 1.1;
    }

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      toast.error(t('Feerate should be greater than') + ' ' + 1);
      setLoading(false);
      return;
    }

    let paramUtxos;
    let paymentUtxos;

    if (isDomainInscribeTransfer) {
      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        provider: wallet.domain, 
        key: strToHex(tempText),
        receiverAddress: receiveAddress
      }
      paymentUtxos = await getOp20UtxosForTransfer(paramUtxos)
    }
    else {
      let selectedUtxos = [];

      for(let data of selectedDomainNameData) {
        if (data.domain == selectedDomainName) {
          selectedUtxos.push({
            txId: data.utxo,
            vout: data.vout,
            value: data.value,
            ownerAddress: wallet.nostrOrdinalsAddress
          })
          break;
        }
      }

      paramUtxos = {
        paymentAddress: wallet.nostrPaymentAddress, 
        fundingAddress: op20FeeAddress, 
        fundingAmount: feeValues.serviceFee, 
        paymentPubkey: wallet.paymentPublicKey, 
        feeRate: tempfeerate, 
        provider: wallet.domain, 
        balanceUtxos: selectedUtxos,
        receiverAddress: receiveAddress
      }
      paymentUtxos = await getOp20UtxosForUtxoTransfer(paramUtxos)
    }

    setShow(true);
    setInscriptionStatus(false);
    let isSuccess = true;
    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        setShow(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      setShow(false);
      return;
    }

    if (isSuccess) {
      setLoading(false);
      setInscriptionStatus(true);
    }
    setLoading(false);
  }

  const onDrop = useCallback( async (acceptedFiles) => {
    let tempSelectedFiles = [];
    let tempFileData = [];
    let count = 0;
    for (let i = 0; i < acceptedFiles.length; i++) {
      if (acceptedFiles[i]){
        if (acceptedFiles[i].size > 1024) {
          toast.error(t('File size must be less than 1KB'));
          return;
        }

        count++;
        if (count > 5) {
          break;
        }

        tempSelectedFiles.push(acceptedFiles[i]);
        const fileUrl = URL.createObjectURL(acceptedFiles[i]);

        const acceptedFileTypes = ['image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'image/png'];
        // if (!acceptedFileTypes.includes(file.type)) {
        //   setPreviewUrl("");
        // }
        // else {
        //   setPreviewUrl(fileUrl);
        // }

        const readFile = async (file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        };

        try {
          const result = await readFile(acceptedFiles[i]);
          // const base64String = result.replace("data:", "").replace(/^.+,/, "");
          tempFileData.push(result);
        } catch (err) {
          console.error(err);
        }
      }
    }

    setSelectedFiles(tempSelectedFiles);
    setFileData(tempFileData);
    setAmount(tempFileData.length);
  }, []);
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 5,
    multiple: true
  });

  const handleNameAdd = () => {
    if (names.length < 10) {
      setNames([...names, ""]);
    }
    else {
      toast.error(t('You can only add up to 10 domains'));
    }
  }

  const handleDomainNameChange = (value) => {
    setSelectedDomainName(value);
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-1/2 left-1/2" color="pink"/> : <></>
      }
      <div className="flex flex-col gap-5 sm:mt-[80px] mt-10">
        <div className="text-white font-bold sm:text-[32px] text-[20px] text-center w-full font-title">
          OP_RETURN {t('INSCRIBE')}
        </div>
        <div className="flex flex-row gap-2 justify-center items-end max-w-[500px] w-full">
          <div className="flex flex-col gap-2 border-solid border-[2px] border-background1 rounded-md p-2">
            <div className="text-white text-xl font-bold text-center">OP-20</div>
            <div className="flex flex-row gap-2">
              <button className = {`${type == 0 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md sm:px-6 px-3 py-2 font-bold cursor-pointer`} onClick={() => handleType(0)}>{t('Deploy')}</button>
              <button className = {`${type == 1 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md sm:px-8 px-4 py-2 font-bold cursor-pointer`} onClick={() => handleType(1)}>{t('Mint')}</button>
              <button className = {`${type == 2 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md sm:px-8 px-4 py-2 font-bold`} onClick={() => handleType(2)} >{t('Transfer')}</button>
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 py-2">
            <button className = {`${type == 3 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md sm:px-8 px-4 py-2 font-bold cursor-pointer`} onClick={() => handleType(3)} >{t('Inscribe')}</button>
            <button className = {`${type == 4 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md sm:px-8 px-4 py-2 font-bold cursor-pointer`} onClick={() => handleType(4)} >{t('OP_Names')}</button>
          </div>
        </div>
      </div>
      <div className={`flex flex-col bg-gray-900 rounded-md ${type == 2 ? 'max-w-[640px]' : 'max-w-[640px]'} w-full mt-2 px-5 py-3`}>
      {
        type == 0 ? 
        <div className="flex flex-col gap-6 w-full items-center mt-3">
          <div className="w-full">
            <Input label={t('Ticker')} type="text" color="white" value={ticker} onChange={(e) => { handleTicker(e.target.value)}}/>
          </div>
          <div className="w-full">
            <Input label={t('Supply')} type="number" color="white" value={supply} onChange={(e) => { setSupply(e.target.value)}}/>
          </div>
          <div className="w-full">
            <Input label={t('Limit')} type="number" color="white" value={limit} onChange={(e) => { setLimit(e.target.value)}}/>
          </div>
          {/* <div className="w-full">
            <div className="flex flex-col gap-2">
              <label className="text-white text-sm font-medium">
                {t('Upload Image(Optional)')}
              </label>
              <div
                {...getRootProps()}
                className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors
                  ${isDragActive ? 'border-primary bg-primary/10' : 'border-gray-600 hover:border-primary'}`}
              >
                <input {...getInputProps()} />
                {previewUrl ? (
                  <div className="flex flex-col items-center gap-2">
                    <img 
                      src={previewUrl} 
                      alt="Preview" 
                      className="max-w-[200px] max-h-[200px] object-contain"
                    />
                    <p className="text-sm text-gray-400">
                      {t('Click or drag to replace image')}
                    </p>
                  </div>
                ) : (
                  <div className="flex flex-col items-center gap-2">
                    <DocumentDuplicateIcon className="h-8 w-8 text-gray-400" />
                    <p className="text-sm text-gray-400">
                      {isDragActive
                        ? t('Drop the image here')
                        : t('Drag and drop an image here, or click to select')}
                    </p>
                    <p className="text-xs text-gray-500">
                      {t('Only JPEG, PNG, GIF and WebP files are accepted')}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div> */}
        </div> 
        :
        <>
        </>
      }
      {
        type == 1 ? 
        <div className="flex flex-col gap-6 w-full items-center mt-3">
          <div className="w-full relative">
            <Input label={t('Ticker')} type="text" color="white" value={ticker} onChange={(e) => { handleMintTicker(e.target.value)}}/>
            {
              isDeployTickerValid && ticker != '' && ticker != undefined ?
              <div className="text-primary absolute right-5 top-2 font-bold">
                <CheckIcon strokeWidth={2} className="h-5 w-5" /> 
              </div>
              :
              <></>
            }
          </div>
          <div className="w-full">
            <div>{t('Repeat Mint Amount')}</div>
            <div className="flex flex-row gap-3 items-center">
              <Slider className="sm:flex hidden" color="blue" value = {amount * 20} onChange = {(e) => handleSliderAmount(e.target.value)}/>
              <div className="sm:max-w-[200px] w-full">
                <Input type="number" color="white" label = {t('Amount')} className="sm:max-w-[200px] w-full" value={amount} min = {1} max = {5} onChange = {(e) => {handleAmount(e.target.value)}}/>
              </div>
            </div>
          </div>
        </div> 
        :
        <></>
      }
      {
        type == 2 ? 
        <div className="flex flex-col gap-6 w-full items-center mt-3">
          {
            wallet.nostrOrdinalsAddress == '' ?
            <div className="text-primary font-bold text-[24px]">{t('Please connect your wallet.')}</div>
            :
            <div className="flex flex-col gap-5">
              <div className="flex sm:gap-5 gap-2">
                <Radio 
                  name="type" 
                  color="pink" 
                  checked={isInscribeTransfer}
                  onChange={() => setIsInscribeTransfer(true)}
                  className={`${isInscribeTransfer ? 'border-primary' : 'border-white'}`}
                  label={
                    <Typography
                    className={`flex font-medium sm:text-md text-sm  ${isInscribeTransfer ? 'text-primary' : 'text-white'}`}
                    >
                      {t('Transfer (Creates UTXO)')}
                    </Typography>
                  } 
                  defaultChecked 
                />
                <Radio 
                  name="type" 
                  color="pink" 
                  checked={!isInscribeTransfer}
                  onChange={() => setIsInscribeTransfer(false)}
                  className={`${!isInscribeTransfer ? 'border-primary' : 'border-white'}`}
                  label={
                    <Typography
                    className={`flex font-medium sm:text-md text-sm  ${!isInscribeTransfer ? 'text-primary' : 'text-white'}`}
                    >
                      {t('Transfer (Moves UTXO)')}
                    </Typography>
                  } 
                />
              </div>
              <div className="w-full relative">
                <Input label={t('Ticker')} type="text" color="white" value={ticker} onChange={(e) => { handleMintTicker(e.target.value)}}/>
                {
                  isDeployTickerValid && ticker != '' && ticker != undefined ?
                  <div className="text-primary absolute right-5 top-2 font-bold">
                    <CheckIcon strokeWidth={2} className="h-5 w-5" /> 
                  </div>
                  :
                  <></>
                }
              </div>
              <div className="w-full flex flex-col gap-2 px-3 py-3 border-[1px] border-background1 rounded-md text-md">
                <div className="flex flex-row justify-between">
                  <div className="font-bold text-[14px]">{t('Total Balance')}</div>
                  <div className="font-bold text-[14px]">{formatNumberWithCommas(tickerBalance.totalBalance)}</div>
                </div>
                <div className="flex flex-row justify-between">
                  <div className="font-bold text-[14px]">{t('Transferable Balance')}</div>
                  <div className="font-bold text-[14px]">{formatNumberWithCommas(tickerBalance.transferableBalance)}</div>
                </div>
                <div className="flex flex-row justify-between">
                  <div className="font-bold text-[14px]">{t('Available Balance')}</div>
                  <div className="font-bold text-[14px]">{formatNumberWithCommas(tickerBalance.availableBalance)}</div>
                </div>
              </div>

              {
                isInscribeTransfer ?
                <div className="w-full">
                  <Input label={t('Amount')} type="number" color="white" value={amount} onChange={(e) => { setAmount(e.target.value)}}/>
                </div>
                :
                <div className="w-full flex flex-col">
                  <div className="flex flex-row justify-between items-center">
                    <div className="text-white font-bold">{t('Select Utxos')} ({selectedAmount})</div>
                    <Checkbox 
                      color="pink"
                      label={<Typography color="white" className="flex font-medium">{t('ALL')}</Typography>}
                      onClick={(e) => handleCheckAll()}
                      checked = {checkAll}
                    />
                  </div>
                  <div className="grid md:grid-cols-3 grid-cols-1 gap-2 max-h-[300px] overflow-y-auto p-2 border-[1px] border-background1 rounded-md">
                    {
                      balanceUtxos.map((utxo) => {
                        return (
                          <Checkbox 
                            key={utxo.id}
                            color="pink"
                            label={<Typography color="white" className="flex font-medium text-[14px]">{utxo.amount}</Typography>}
                            onClick={(e) => handleChecked(utxo.id)}
                            checked = {utxo.checked}
                          />
                        )
                      })
                    }
                  </div>
                </div>
              }
              {
                isInscribeTransfer ?
                <div className="w-full flex flex-row gap-2 items-center">
                  <Input label={t('Receiver Address Or Domain Name')} type="text" color="white" value={receiveAddress} onChange={(e) => { setReceiveAddress(e.target.value)}}/>
                  {
                    domainForAddress.length > 0 ?
                    <InformationCircleIcon className="h-6 w-6 cursor-pointer text-primary" onClick={() => {setShowDomainForAddress(true)}}/>
                    :
                    <></>
                  }
                </div>
                :
                <div className="w-full">
                  <Input label={t('Receiver Address')} type="text" color="white" value={receiveAddress} onChange={(e) => { setReceiveAddress(e.target.value)}}/>
                </div>
              }
              <div className="text-left w-full text-gray-400 mt-2 sm:text-[16px] text-[14px]">
                {t('Select Network Fee You Want')}:
              </div>
              <div className="grid grid-cols-3 gap-3 w-full mt-3">
                <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
                <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
                <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
              </div>
              {
                feeRateMode == "Custom" ? 
                <div className="flex flex-row gap-3 items-center mt-2">
                  <Slider className= "sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
                  <div className="sm:max-w-[200px] w-full">
                    <Input type="text" color="white" label = "Custom Fee" className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
                  </div>
                </div>
                : 
                <></>
              }
              <div className="m-auto md:w-[400px] w-[260px] mt-2">
                <div className="flex flex-row justify-between mt-1 sm:text-[20px] text-[14px]">
                  <div className="font-bold">{t('Total Cost')}</div>
                  <div className="text-right font-bold text-blue-600">{feeValues["totalFee"] / Math.pow(10, 8)} BTC</div>
                </div> 
              </div>
              <button className = {`bg-primary hover:bg-primary-hover text-[16px] text-white rounded-md px-8 py-2 font-bold mt-5`} onClick={() => handleTransfer()}>{t('Transfer')}</button>
            </div>
          }
        </div> 
        :
        <></>
      }
      {
        type == 3 ?
        <div className="flex flex-col gap-6 w-full items-center mt-3">
          <div className="w-full">
            {
              selectedFiles.length > 0 ?
              <div className="flex flex-col gap-2">
                <div className="text-primary font-bold">{t('Selected Files:')}</div>
                {
                  selectedFiles.map((file) => {
                    return (
                      <div className="text-white font-bold ml-3" key={uuidv4()}>{file.name}</div>
                    )
                  })
                }
              </div>
              :
              <></>
            }
            <div className="flex flex-col gap-2">
              <div
                {...getRootProps()}
                className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors
                  ${isDragActive ? 'border-primary bg-primary/10' : 'border-gray-600 hover:border-primary'}`}
              >
                <input {...getInputProps()} />
                {previewUrl ? (
                  <div className="flex flex-col items-center gap-2">
                    <img 
                      src={previewUrl} 
                      alt="Preview" 
                      className="max-w-[200px] max-h-[200px] object-contain"
                    />
                    <p className="text-sm text-gray-400">
                      {t('Click or drag to replace file')}
                    </p>
                  </div>
                ) : (
                  <div className="flex flex-col items-center gap-2">
                    <DocumentDuplicateIcon className="h-8 w-8 text-gray-400" />
                    <p className="text-sm text-gray-400">
                      {isDragActive
                        ? t('Drop the file here')
                        : t('Drag and drop a file here, or click to select')}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        :
        <></>
      }
      {
        type == 4 ?
        <div className="flex flex-col gap-2">
          <div className="flex flex-row mb-5">
            <button className = {`${isDomainMint ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-s-md sm:px-8 px-4 py-2 font-bold cursor-pointer`} onClick={() => setIsDomainMint(true)}>{t('Inscribe')}</button>
            <button className = {`${!isDomainMint ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-e-md sm:px-8 px-4 py-2 font-bold cursor-pointer`} onClick={() => setIsDomainMint(false)}>{t('Transfer')}</button>
          </div>
          {
            isDomainMint ?
            <div className="m-auto w-full">
              <div className="ml-1 text-primary cursor-pointer" onClick={() => {setShowHotDomain(true)}}>
                {t('Hot Available Domains')} &gt;&gt;
              </div>
              <div className="flex flex-col gap-2 mb-2 mt-1">
                {
                  names.map((name, index) => {
                    return (
                      <div className="flex flex-row gap-2">
                        <Input label={t('Domain name (e.g. sats.op)')} type="text" color="white" value={name} onChange={(e) => { setNames(names.map((n, i) => i === index ? e.target.value : n))}}/>
                        {
                          index > 0 ?
                          <div className="flex flex-row justify-center border-[1px] border-primary border-solid rounded-md text-center px-4 text-primary font-bold text-[24px] cursor-pointer" onClick = {() => setNames(names.filter((n, i) => i !== index))}>-</div>
                          :
                          <></>
                        }
                      </div>
                    )
                  })
                }
                <div 
                  className="flex flex-row justify-center border-[1px] border-primary border-solid rounded-md text-center text-primary font-bold text-[24px] cursor-pointer" 
                  onClick = {() => handleNameAdd()}>
                    +
                </div>
              </div>
            </div>
            :
            <div className="m-auto w-full flex flex-col gap-2">
              {
                wallet.nostrOrdinalsAddress == '' ?
                <div className="text-primary font-bold text-[24px]">{t('Please connect your wallet.')}</div>
                :
                <div className="flex flex-col gap-5 mb-2">
                  <div className="flex sm:gap-5 gap-2">
                    <Radio 
                      name="type" 
                      color="pink" 
                      checked={isDomainInscribeTransfer}
                      onChange={() => setIsDomainInscribeTransfer(true)}
                      className={`${isDomainInscribeTransfer ? 'border-primary' : 'border-white'}`}
                      label={
                        <Typography
                        className={`flex font-medium sm:text-md text-sm  ${isDomainInscribeTransfer ? 'text-primary' : 'text-white'}`}
                        >
                          {t('Transfer (Creates UTXO)')}
                        </Typography>
                      } 
                      defaultChecked 
                    />
                    <Radio 
                      name="type" 
                      color="pink" 
                      checked={!isDomainInscribeTransfer}
                      onChange={() => setIsDomainInscribeTransfer(false)}
                      className={`${!isDomainInscribeTransfer ? 'border-primary' : 'border-white'}`}
                      label={
                        <Typography
                        className={`flex font-medium sm:text-md text-sm  ${!isDomainInscribeTransfer ? 'text-primary' : 'text-white'}`}
                        >
                          {t('Transfer (Moves UTXO)')}
                        </Typography>
                      } 
                    />
                  </div>
                  {
                    selectedDomainNameData.length > 0 ?
                    <Select 
                      label = {t('Select Domain Name')} 
                      className="text-white"
                      onChange={handleDomainNameChange}
                    >
                    {
                      selectedDomainNameData.map((data) => 
                        <Option value = {data.domain} key={uuidv4()} className="font-bold">{data.domain}</Option>
                      )
                    }
                    </Select>
                    :
                    <div className="text-gray-400">{t('No domain name found')}</div>
                  }
                </div>
              }
            </div>
          }
        </div>
        
      :<></>
      }
      {
        type == 2 ?
        <></> :
        <div className="flex flex-col gap-3 w-full items-center">
          {
            type == 4 ?
            <div className="m-auto w-full mt-3">
              <Input label={t('Receiver Address')} type="text" color="white" value={receiveAddress} onChange={(e) => { setReceiveAddress(e.target.value)}}/>
            </div> 
            :
            <div className="flex flex-row gap-2 m-auto w-full mt-3 items-center">
              <Input label={t('Receiver Address Or Domain Name')} type="text" color="white" value={receiveAddress} onChange={(e) => { setReceiveAddress(e.target.value)}}/>
              {
                domainForAddress.length > 0 ?
                <InformationCircleIcon className="h-6 w-6 cursor-pointer text-primary" onClick={() => {setShowDomainForAddress(true)}}/>
                :
                <></>
              }
            </div>
          }
          {
            type == 3 ?
            <div className="w-full mt-5">
              <Input label={t('Collection Name(Optional)')} type="text" color="white" value={collectionName} onChange={(e) => { setCollectionName(e.target.value)}}/>
            </div>
            :
            <></>
          }
          <div className="text-left w-full text-gray-400 mt-2 sm:text-[16px] text-[14px]">
            {t('Select Network Fee You Want')}:
          </div>
          <div className="grid grid-cols-3 gap-3 w-full mt-3">
            <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
            <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
            <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
          </div>
          {
            feeRateMode == "Custom" ? 
            <div className="flex flex-row gap-3 items-center mt-2">
              <Slider className= "sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
              <div className="sm:max-w-[200px] w-full">
                <Input type="text" color="white" label = "Custom Fee" className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
              </div>
            </div>
            : 
            <></>
          }
          <div className="m-auto md:w-[400px] w-[260px] mt-2">
            <div className="flex flex-row justify-between mt-1 sm:text-[20px] text-[14px]">
              <div className="font-bold">{t('Total Cost')}</div>
              <div className="text-right font-bold text-blue-600">{feeValues["totalFee"] / Math.pow(10, 8)} BTC</div>
            </div> 
          </div>

          {
            type == 4 ?
            <></>
            :
            <>
              {
                mintTextDraft.length > 79 ?
                <>
                  <div className ="items-center mt-2 text-white">
                    {t('MARA fee rate is currently')} <span className="font-bold text-primary text-xl">{maraFeeRate}</span>. {t('We recommend')} <span className="font-bold text-primary text-xl">{Math.ceil(parseInt(maraFeeRate * 1.2))}</span> {t('for faster confirmation. Lower rates may cause delays, adjust accordingly.')}
                  </div>
                  <div className="text-red-700 font-bold">
                    {t('Bytes Exceeded Error Message')}
                  </div>
                </>
                :
                <></>
              }
            </>
          }
          <button className = {`bg-primary w-full hover:bg-primary-hover text-[16px] text-white rounded-md px-8 py-2 font-bold mt-5`} onClick={() => handleSubmit(type)}>{type == 0 ? t('DEPLOY') : type == 1 ? t('MINT') : type == 3 || (type == 4 && isDomainMint) ? t('INSCRIBE') : t('TRANSFER')}</button>
        </div>
      }
      </div>

      <Op20HotDomains showHotDomain = {showHotDomain} setShowHotDomain = {setShowHotDomain} handleDomain = {handleDomain} />

      <Dialog
        open={show}
        size={"sm"}
      >
        <DialogHeader>
          {
            inscriptionStatus ? <>
                {
                  type == 0 ? 
                  <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 text-[32px] font-bold text-primary">
                    <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                    <span className="text-primary sm:text-[32px] text-[20px]">
                      {t('Deployment Successful')}.</span>
                  </div>
                  :
                  <></>
                }
                {
                  type == 1 ? 
                  <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 text-[32px] font-bold text-primary">
                    <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                    <span className="text-primary sm:text-[32px] text-[20px]">
                      {t('Mint successful')}.</span>
                  </div>
                  :<></>
                }
                {
                  type == 3 || type == 4 ? 
                  <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 text-[32px] font-bold text-primary">
                    <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                    <span className="text-primary sm:text-[32px] text-[20px]">
                      {t('Inscribe successful')}.</span>
                  </div>
                  :<></>
                }
                {
                  type == 2 ? 
                  <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 text-[32px] font-bold text-primary">
                    <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                    <span className="text-primary sm:text-[32px] text-[20px]">
                      {t('Transfer successful')}.</span>
                  </div>
                  :<></>
                }
              </>
              :
              <div className="flex flex-row w-full justify-center mt-6 sm:text-[32px] text-[20px] font-bold text-primary">
                {t('Inscribing Now')}
              </div>
          }
        </DialogHeader>
        <DialogBody>
          <div className={`flex flex-col gap-3 w-full ${inscriptionStatus ? 'min-h-[100px]' : 'min-h-[160px]'}`}>
            {
              inscriptionStatus ? 
              <div className="flex flex-col items-center gap-4 ">
                {
                  type == 2 || type == 4 ?
                  <div className="flex flex-col gap-3">
                    <div className="text-blue-600 font-bold text-[18px]">{t('Please wait for confirmation.')}</div>
                  </div>
                  :
                  <div className="max-h-[400px] overflow-y-auto flex flex-col gap-3">
                  {
                    maraData.map((data, index) => {
                      return (<div className="flex flex-col gap-3 items-start border-blue-800 border-2 rounded-md p-2 w-full" key={uuidv4()}>
                          <div className="text-black font-bold">Tx{index + 1}:</div>
                          {
                            data.status == 'success' ? 
                            <div>
                            {
                              data.isMara ?
                              <div className="text-black font-bold">{t('Please check transaction here')}: <a href={`https://slipstream.mara.com/status?txid=${data.txid}`} className="text-primary cursor-pointer" target="_blank" rel="noopener noreferrer">{formatInscriptionIdMini(data.txid)}</a></div>
                              :
                              <div className="text-black font-bold">{t('Please check transaction here')}: <a href={`https://mempool.space/tx/${data.txid}`} className="text-primary cursor-pointer" target="_blank" rel="noopener noreferrer">{formatInscriptionIdMini(data.txid)}</a></div>
                            }
                            </div>
                            :
                            <>
                            {
                              data.isMara ?
                              <div className="flex flex-col items-center gap-4">
                                <div className="text-red-700 font-bold">{t('Mara fail message')}: <a href={`https://slipstream.mara.com`} className="text-primary cursor-pointer" target="_blank" rel="noopener noreferrer">{t('MARA')}</a></div>
                                <div className="flex flex-row items-center gap-2 text-blue-700 font-bold cursor-pointer" onClick={() => {navigator.clipboard.writeText(data.hex)}}>
                                  <span>{t('Copy Transaction Hex')}</span>
                                  <DocumentDuplicateIcon className="h-5 w-5 cursor-pointer"  />
                                </div>
                                <textarea className="w-full h-[320px] border-2 border-gray-800 rounded-md p-2 font-black" value={data.hex}></textarea>
                              </div>
                              :
                              <div className="flex flex-col items-center gap-4">
                                <div className="text-red-700 font-bold">{t('Mara fail message')}: <a href={`https://mempool.space/tx/push`} className="text-primary cursor-pointer" target="_blank" rel="noopener noreferrer">{t('Send to Mempool')}</a></div>
                                <div className="flex flex-row items-center gap-2 text-blue-700 font-bold cursor-pointer" onClick={() => {navigator.clipboard.writeText(data.hex)}}>
                                  <span>{t('Copy Transaction Hex')}</span>
                                  <DocumentDuplicateIcon className="h-5 w-5 cursor-pointer"  />
                                </div>
                                <textarea className="w-full h-[320px] border-2 border-gray-800 rounded-md p-2 font-black" value={data.hex}></textarea>
                              </div>
                            }
                            </>
                          }   
                      </div>)
                    })
                  }
                  </div>
                }
                <div className="w-[180px] mt-5">
                  <Button
                    onClick={() => {
                      setShow(false);
                      setInscriptionStatus(false);
                    }}
                    fullWidth
                  >{t('Close')}</Button>
                </div>
              </div>
              :
              <div className="flex flex-col items-center gap-5">
                <div className="flex flex-row justify-center w-full font-semibold text-[#616161] sm:text-[20px] text-[14px] px-6 text-center">
                  {t('Do Not Close Window Info Message')}
                </div>
                <Spinner className="h-12 w-12" />
              </div>
            }
          </div>
        </DialogBody>
      </Dialog>
      <Dialog
        open={showDomainForAddress}
        size={"sm"}
        className="bg-black border-[1px] border-gray-800 border-solid"
      >
        <DialogHeader>
          <div className="text-primary font-bold text-[24px] w-full text-center mt-5">{t('Domain Name')}</div>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-2 items-center justify-center">
            <div className="flex flex-col gap-3 max-h-[400px] overflow-y-auto w-[250px] border-background1 rounded-md p-3">
              {
                domainForAddress.map((data) => {
                  return <div key={uuidv4()} className="text-white font-bold text-[16px] cursor-pointer hover:text-primary" onClick={() => {setReceiveAddress(data.domain); setShowDomainForAddress(false);}}>{data.domain}</div>
                })
              }
            </div>
            <button onClick={() => {setShowDomainForAddress(false)}} className="bg-gray-600 hover:bg-gray-700 text-white font-bold text-[16px] rounded-md px-8 py-2 mt-3">{t('Close')}</button>
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
